// #2111 — filename for "Download local data" (SyncStatus.jsx), which
// replaces the old clipboard-only "Copy outbox" export with a real file
// download of the whole local database (see local/db.js's dumpDatabase).
// Card spec: fv_scribe_<email snake cased>_<timestamp>.json.

// Lowercases and collapses every run of non-alphanumeric characters (an
// email's `@` and `.` both included) to a single underscore, trimming any
// leading/trailing underscore left behind. "Jane.Doe+scribe@example.com"
// becomes "jane_doe_scribe_example_com" rather than a filename carrying raw
// punctuation a browser/OS may refuse or silently mangle.
export function snakeCaseEmail(email) {
  return String(email ?? "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

// A filesystem-safe, still-sortable UTC timestamp derived from
// toISOString(): colons are illegal in a Windows filename, so both colons
// and the milliseconds' literal dot are normalized to `-`
// ("2026-08-30T14:15:00.000Z" -> "2026-08-30T14-15-00-000Z").
function timestampForFilename(now) {
  return now.toISOString().replace(/[:.]/g, "-");
}

// `email` may be null/undefined (auth not yet resolved, or a claim that
// genuinely has none) — falls back to "unknown" rather than ever producing
// a filename with an empty segment (a trailing "fv_scribe__2026...json").
export function localDataExportFilename(email, now = new Date()) {
  const emailPart = snakeCaseEmail(email) || "unknown";
  return `fv_scribe_${emailPart}_${timestampForFilename(now)}.json`;
}
